<template>
  <div
    class="app-banner"
    :class="[backgroundColor]"
    data-cy="app-banner"
  >
    <v-icon
      :class="iconColor"
      :size="24"
    >
      {{ icon }}
    </v-icon>
    <p class="sn-text-primary-03">
      {{ message }}
    </p>
    <sn-btn
      v-if="primaryText"
      type="text"
      :text="primaryText"
      text-case="no-format"
      @click="$emit('primary-click')"
    />
    <sn-btn
      v-if="secondaryText"
      type="text"
      :text="secondaryText"
      text-case="no-format"
      @click="$emit('secondary-click')"
    />
  </div>
</template>

<script>
import snBtn from '~/components/snui/v2/snBtn/snBtn'

export default {
  name: 'SnBanner',
  components: {
    snBtn
  },
  props: {
    message: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: String,
      default: 'info',
      required: false,
      validator (type) {
        return ['info', 'warning', 'error', 'success'].includes(type)
      }
    },
    primaryText: {
      type: String,
      required: false,
      default: ''
    },
    secondaryText: {
      type: String,
      required: false,
      default: ''
    }

  },
  computed: {
    icon () {
      switch (this.type) {
        case 'error':
          return '$snRestricted'
        case 'warning':
          return '$snWarning'
        case 'success':
          return '$snCheckCircle'
        case 'info':
          return '$snInfo'
        default:
          return '$snInfo'
      }
    },
    backgroundColor () {
      switch (this.type) {
        case 'error':
          return 'sn-background-error-01'
        case 'warning':
          return 'sn-background-caution-01'
        case 'success':
          return 'sn-background-success-01'
        case 'info':
          return 'sn-background-gray-01'
        default:
          return 'sn-background-gray-01'
      }
    },
    iconColor () {
      switch (this.type) {
        case 'error':
          return 'sn-text-error'
        case 'warning':
          return 'sn-text-caution-04'
        case 'success':
          return 'sn-text-success-04'
        case 'info':
          return 'sn-text-primary-03'
        default:
          return 'sn-text-primary-03'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';
  .app-banner {
    padding: 24px;
    font-size: 17px;
    line-height: 24px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: $font-family-primary;
    position: fixed;
    top: 0;
    gap: 8px;
    width: 100%;

    p {
      padding: 0;
      margin: 0;
    }
  }
</style>
